import styled from 'styled-components';
import { media } from '@cld/style-utils';
import { typography } from '@cld/typography';

export const Wrapper = styled.nav`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;

  height: 100%;
  width: 200px;
  flex-direction: column;
  scroll-snap-type: y mandatory;

  // styling TODO:APPS-233
  background-color: #fafafa;
  border-right: 1px solid #c6d1db;
  border-bottom: none;

  @media ${media.phone()} {
    height: auto;
    width: auto;
    flex-direction: row;
    scroll-snap-type: x mandatory;

    // styling TODO:APPS-233
    border-right: none;
    border-bottom: 1px solid #c6d1db;
  }
`;

export const Item = styled.div`
  flex: 0 0 auto;
  scroll-snap-align: start;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;

  // styling TODO:APPS-233
  ${typography.sm.regular};
  line-height: 44px;
  height: 44px;

  padding: 0 16.25px;
  background-color: ${(props) => (props.selected ? '#F0F6FE' : '#fafafa')};
  color: ${(props) => (props.selected ? '#005CE4' : '#323A45')};
  border-bottom: none;
  border-left: ${(props) => (props.selected ? '2px solid #005CE4' : 'none')};

  @media ${media.phone()} {
    width: ${(props) => 100 / props.horizontalLimit}%;
    text-align: center;

    // styling TODO:APPS-233
    border-bottom: ${(props) => (props.selected ? '2px solid #005CE4' : 'none')};
    border-left: none;
  }
`;
